import { render } from "./Navbar.vue?vue&type=template&id=18878fd6&scoped=true&ts=true"
import script from "./Navbar.vue?vue&type=script&lang=ts"
export * from "./Navbar.vue?vue&type=script&lang=ts"

import "./Navbar.vue?vue&type=style&index=0&id=18878fd6&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18878fd6"]])

export default __exports__